var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.052,
    height: 20.052,
    viewBox: "0 0 20.052 20.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-svg-colored-linear-gradient",
    x1: -1.971,
    y1: 2.61,
    x2: -1.264,
    y2: 3.317,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2489be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575b3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.051,7.025A10.026,10.026,0,1,0,27.077,17.051,10.026,10.026,0,0,0,17.051,7.025ZM14.376,21.9h-2.2V14.786h2.2Zm-1.111-8.043a1.312,1.312,0,1,1,1.3-1.312A1.307,1.307,0,0,1,13.265,13.855ZM22.625,21.9H20.435V18.165c0-1.024-.389-1.6-1.2-1.6-.881,0-1.341.6-1.341,1.6V21.9H15.783V14.786h2.111v.958a2.48,2.48,0,0,1,2.143-1.175c1.508,0,2.588.921,2.588,2.826v4.5Z",
    transform: "translate(-7.025 -7.025)",
    fill: "url(#linkedin-svg-colored-linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinColored);
export default __webpack_public_path__ + "static/media/linkedin-colored.09ae65f53884e35f23c49b3066fa5825.svg";
export { ForwardRef as ReactComponent };